import { useEffect } from 'react';
import { Outlet, useSearchParams, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { MainNavbar } from '@/presentation/layout/MainNavbar';
import { useAuth } from '@/presentation/hook/useAuth';
import { LoadingSpinner } from '@/presentation/component/ui';
import 'react-toastify/dist/ReactToastify.css';

export const PublicLayout = () => {
  const { checkAuth, isLoading } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    if (searchParams.has('accessDenied')) {
      toast.error(t('admin.accessDenied'));
      navigate('/', { replace: true });
    }
  }, [searchParams, navigate, t]);

  return (
    <div className="min-h-screen bg-[var(--color-bg)]">
      {isLoading ? (
        <div className="flex min-h-screen items-center justify-center">
          <LoadingSpinner size="lg" />
        </div>
      ) : (
        <>
          <MainNavbar />
          <main>
            <Outlet />
          </main>
        </>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};
